// @ts-check
// Bootstrap mínimo (03-frontend.md §8.1): main.js solo valida configuración
// pública y delega en el arranque. No ejecuta lógica de negocio.
import { bootstrap } from './app/bootstrap.js';

bootstrap().catch((err) => {
  // Sin exponer detalles internos; el error-boundary maneja el fallo no recuperable.
  console.error('[bootstrap] fallo no recuperable');
  throw err;
});
